"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AWTBondSerializer_1 = require("../common/AWTBondSerializer");
var AWTRecordBatcher = /** @class */ (function () {
    function AWTRecordBatcher(_maxRequestSize, _outboundQueue) {
        this._maxRequestSize = _maxRequestSize;
        this._outboundQueue = _outboundQueue;
        this._currentBatch = {};
        this._currentBatchSize = 0;
    }
    AWTRecordBatcher.prototype.addEventToBatch = function (event) {
        var serializedEvent = AWTBondSerializer_1.default.getEventBlob(event);
        if (serializedEvent.length > this._maxRequestSize) {
            //single event too big
            return;
        }
        if (this._currentBatchSize + serializedEvent.length > this._maxRequestSize) {
            this.flushBatch();
        }
        else {
            if (this._currentBatch[event.tenantToken] === undefined) {
                this._currentBatch[event.tenantToken] = [];
            }
            this._currentBatch[event.tenantToken].push(serializedEvent);
            this._currentBatchSize += serializedEvent.length;
        }
    };
    AWTRecordBatcher.prototype.flushBatch = function () {
        if (this._currentBatchSize > 0) {
            this._outboundQueue.push(this._currentBatch);
            this._currentBatch = {};
            this._currentBatchSize = 0;
        }
    };
    return AWTRecordBatcher;
}());
exports.default = AWTRecordBatcher;
